import { SET_CURRENT_USER, USER_LOADING, USER_LOADED } from "../types";

// Login - get user token
export const loginUser = (user, history, closeModal) => (dispatch) => {
  localStorage.setItem("token", "5ebe2294ecd0e0f08eab7690d2a6ee69");
  localStorage.setItem("user", JSON.stringify(user));
  dispatch(setCurrentUser(user));
  dispatch(setUserLoaded());
  // closeModal();
  history.push("/auth/home");
};

// Set logged in user
export const setCurrentUser = (userData) => {
  return {
    type: SET_CURRENT_USER,
    payload: userData,
  };
};

// User loading
export const setUserLoading = () => {
  return {
    type: USER_LOADING,
  };
};

// User loaded
export const setUserLoaded = () => {
  return {
    type: USER_LOADED,
  };
};

// Log user out
export const logoutUser = (history) => (dispatch) => {
  // console.log(history);
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  dispatch(setCurrentUser({}));
  if (history) {
    history.push("/");
  }
};
